export  const pcDateComparisonDefaultSelector = [

  {
    "name_cn": "指标",
    "name_en": "Metrics",
    "key": "metrics",
    "visible": 1,
    "default": [
      "new_users" , "active_users"
    ]
  },

  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 0,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "语言",
    "name_en": "Language",
    "key": "lang",
    "visible": 0,
    "default": ["255"]
  }
];

export  const mobileDateComparisonDefaultSelector = [

  {
    "name_cn": "指标",
    "name_en": "Metrics",
    "key": "metrics",
    "visible": 1,
    "default": [
      "new_users" , "active_users"
    ]
  },
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  }
];

// 休闲游戏事件对比专用默认选择器
export  const casualDateComparisonDefaultSelector = [

  {
    "name_cn": "指标",
    "name_en": "Metrics",
    "key": "metrics",
    "visible": 1,
    "default": [
      "active_users" , "d2"
    ]
  },
  {
    "name_cn": "区服",
    "name_en": "Zone",
    "key": "zone",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "区域",
    "name_en": "Region",
    "key": "region",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "渠道",
    "name_en": "Channel",
    "key": "channel",
    "visible": 1,
    "default": [
      "255"
    ]
  },
  {
    "name_cn": "平台",
    "name_en": "Platform",
    "key": "system",
    "visible": 1,
    "default": [
      "255"
    ]
  }
];